import { CustomizerStateType } from './types';

export const GoogleMapApiKeySelector = (s: CustomizerStateType) => s.customizer.googleMapApiKey;
